import React, { useEffect, useState } from "react";
import AlertBox from "./AlertBox";
import noImage from "../data/images/no-image1.jpeg";
import { BsPersonAdd } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { useStateContext } from "../contexts/ContextProvider";
import EditRoom from "./EditRoom";
import AddRoommate from "./AddRoommate";
import RoomIcons from "./RoomIcons";
import ActiveLeaseCard from "./ActiveLeaseCard";
import TransactionsModal from "./TransactionsModal";
import MessagesModal from "./MessagesModal";
import PublishRoomModal from "./PublishRoomModal";
import EndLeaseModal from "./EndLeaseModal";
import { useNavigate } from "react-router-dom";

import {
  apiDeleteRoom,
  apiUpdateChore,
  apiUpdateRoom,
  apiDeleteLease,
  apiDeletePublishedRoom,
  apiUpdatePublishedRoom,
} from "../services/apiService";
import LandlordSignLeaseModal from "./LandlordSignLeaseModal";
import StripeOnboardingModal from "./StripeOnboardingModal";
import NavigateBack from "./NavigateBack";
import SliderButton from "./SliderButton";
import AcceptPaymentModal from "./AcceptPaymentModal";

const ManageRoom = (props) => {
  const { currentProperty, currentRoomId } = props;
  const {
    user,
    rooms,
    setRooms,
    leases,
    setLeases,
    chores,
    setChores,
    publishedRooms,
    setPublishedRooms,
    alert,
    handleAlert,
    modal,
    handleModal,
    checkTenantAuth,
  } = useStateContext();

  const [preventDelete, setPreventDelete] = useState(false);
  const [stripeOnboarding, setStripeOnboarding] = useState(false);

  const navigate = useNavigate();

  let currentRoom = rooms.find((x) => x.id === currentRoomId);
  let currentLease = leases.find((x) => x.roomId === currentRoomId);

  useEffect(() => {
    if (currentLease) {
      setPreventDelete(true);
    } else {
      setPreventDelete(false);
    }

    // currentLease = leases.find((x) => x.roomId === currentRoomId);
    // console.log("leases has changed");
  }, [leases, currentLease, preventDelete]);

  const handleDeleteRoom = async () => {
    const response = await apiDeleteRoom(currentRoomId);
    if (response.hasError) {
      //TODO: Add error message
      return;
    } else {
      let roomsCopy = rooms;
      let newRooms = roomsCopy.toSpliced(
        roomsCopy.findIndex((x) => x.id === currentRoomId),
        1
      );
      setRooms(newRooms);
      handleModal("manageRoom");

      // remove room from chores rotation (TODO: seperate in to own fucntion)
      let choreCopy = chores.find((x) => x.propertyId === currentProperty.id);
      if (choreCopy && choreCopy.leaseIds.length > 0) {
        let newArray = choreCopy.leaseIds.toSpliced(
          choreCopy.leaseIds.indexOf(currentRoomId),
          1
        );
        choreCopy.rooms = newArray;
        // update associated chores (TODO: seperate into own function)
        const response = await apiUpdateChore(choreCopy.id, choreCopy);
        if (response.hasError) {
          return;
        } else {
          setChores(
            chores.toSpliced(
              chores.indexOf((x) => x.id === choreCopy.id),
              1,
              response.data // changed from 'choreCopy'
            )
          );
        }
      }
    }
  };

  const handleRoomUpdate = async (room) => {
    const response = await apiUpdateRoom(room.id, room);
    if (response.hasError) {
      // TODO: add error message
      return;
    } else {
      setRooms(
        rooms.toSpliced(
          rooms.findIndex((x) => x.id === room.id),
          1,
          response.data
        )
      );
      if (room.isPublished) updatePublishedRoom(response.data);
    }
  };

  const deleteActiveLease = async (leaseId) => {
    const response = await apiDeleteLease(leaseId);
    if (response.hasError) {
      // TODO: add error message
      console.log(response.error);
      return;
    } else {
      setLeases(
        leases.toSpliced(
          leases.findIndex((x) => x.id === leaseId),
          1
        )
      );
    }
  };

  const removeFromPublished = () => {
    currentRoom.isPublished = false;
    currentRoom.available = "";
    handleRoomUpdate(currentRoom);
    handleRemovePublishedRoom(currentRoom.uuid);
  };

  //TODO: handle on the backend?
  const updatePublishedRoom = async (room) => {
    const response = await apiUpdatePublishedRoom(room.uuid, room);
    if (response.hasError) {
      //TODO: add error message
      console.log(response.error);
      return;
    } else {
      setPublishedRooms(
        publishedRooms.toSpliced(
          publishedRooms.findIndex((x) => x.roomUuid === room.uuid),
          1,
          response.data
        )
      );
    }
  };

  const handleRemovePublishedRoom = async (uuid) => {
    const response = await apiDeletePublishedRoom(uuid);
    if (response.hasError) {
      //TODO: add error message
      return;
    } else {
      setPublishedRooms(
        publishedRooms.toSpliced(
          publishedRooms.findIndex((x) => x.roomUuid === uuid),
          1
        )
      );
    }
  };

  return (
    <div
      className="w-screen fixed left-0 right-0 top-0 bottom-0 bg-white  
      overflow-y-auto overscroll-none mt-20 z-10"
    >
      <NavigateBack
        zIndex="z-10"
        returnText="Back to property"
        modalNavigation={() => {
          handleModal("manageRoom");
        }}
      />
      {/* <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10 
     overflow-y-auto overscroll-y-none"> */}
      {alert.tenantUpgrade && (
        <AlertBox
          alertType="tenantUpgrade"
          handleAlert={handleAlert}
          alertFunc={() => navigate("/account/subscription")}
        />
      )}
      {alert.removeFromPublished && (
        <AlertBox
          alertType="removeFromPublished"
          handleAlert={handleAlert}
          alertFunc={removeFromPublished}
        />
      )}
      {alert.deleteRoom && (
        <AlertBox
          alertType="deleteRoom"
          handleAlert={handleAlert}
          alertFunc={handleDeleteRoom}
        />
      )}
      {modal.editRoom && (
        <EditRoom
          propertyId={currentProperty.id}
          currentRoomId={currentRoomId}
          handleRoomUpdate={handleRoomUpdate}
        />
      )}
      {modal.addRoommate && (
        <AddRoommate
          room={currentRoom}
          propertyId={currentProperty.id}
          lease={currentLease ? currentLease : false}
          setStripeOnboarding={setStripeOnboarding}
        />
      )}
      {modal.publishRoom && (
        <PublishRoomModal
          room={currentRoom}
          handleRoomUpdate={handleRoomUpdate}
        />
      )}
      {modal.transactions && <TransactionsModal roomId={currentRoom.id} />}
      {modal.messages && (
        <MessagesModal
          senderId={currentLease.landlordId}
          recipientId={currentLease.tenantId}
        />
      )}
      {modal.acceptPayment && <AcceptPaymentModal lease={currentLease} />}
      {modal.landlordSignLease && (
        <LandlordSignLeaseModal lease={currentLease} />
      )}
      {stripeOnboarding && (
        <StripeOnboardingModal
          setStripeOnboarding={setStripeOnboarding}
          lease={currentLease}
        />
      )}
      {modal.endLease && (
        <EndLeaseModal
          lease={currentLease}
          deleteActiveLease={deleteActiveLease}
        />
      )}
      <div className="flex bg-gray-300 drop-shadow-lg mt-10">
        <div>
          <img
            src={
              currentRoom.images[0] instanceof Blob
                ? URL.createObjectURL(currentRoom.images[0])
                : currentRoom.images[0] || noImage
            }
            alt="Roomate's Avatar"
            className="h-32 w-32 object-cover border-black border-r-1"
          />
        </div>
        <div className="relative w-2/3 sm:w-5/6 ml-2 capitalize">
          <div className="flex justify-between items-center">
            <div
              className="text-2xl hover:text-blue-500 hover:underline truncate pr-2"
              onClick={() => {
                handleModal("editRoom");
              }}
            >
              {currentRoom.roomName}
            </div>
            {currentRoom.isPublished && (
              <div
                className="text-2xl hover:text-blue-500 cursor-pointer pt-1 pr-2"
                onClick={() => {
                  navigate(`/rooms/${currentRoom.uuid}`);
                }}
              >
                <div
                  className="flex items-center text-blue-500 hover:text-blue-700 
                  border-1 border-blue-500 rounded-lg px-1 py-.5"
                >
                  <FaEye className="text-sm cursor-pointer" />
                  <div className="text-sm pl-1">View</div>
                </div>
              </div>
            )}
          </div>
          <div className="w-48 text-xl">
            <RoomIcons currentRoom={currentRoom} />
          </div>
          <div
            className={`flex items-center mt-3 pr-3 absolute bottom-2 cursor-pointer ${
              user.hasPublished ? "" : "text-snappily-orange animate-bounce"
            }`}
          >
            <div
              onClick={() => {
                currentRoom.isPublished
                  ? handleAlert("removeFromPublished")
                  : handleModal("publishRoom");
              }}
            >
              Publish:
            </div>
            <SliderButton
              value={currentRoom.isPublished}
              customFunc={() => {
                currentRoom.isPublished
                  ? handleAlert("removeFromPublished")
                  : handleModal("publishRoom");
              }}
            />
          </div>
          <div>
            <div className="flex absolute right-3 bottom-0">
              <div
                className="text-blue-500 hover:text-blue-700 cursor-pointer pr-5"
                onClick={() => {
                  handleModal("editRoom");
                }}
              >
                Edit
              </div>
              <div
                className={`${
                  preventDelete
                    ? "text-gray-500"
                    : "text-red-500 hover:text-red-700 cursor-pointer"
                }`}
                onClick={() => {
                  if (!preventDelete) handleAlert("deleteRoom");
                }}
              >
                Delete
              </div>
            </div>
          </div>
        </div>
      </div>
      {currentLease ? (
        <ActiveLeaseCard
          lease={currentLease}
          senderId={currentLease.landlordId}
          recipientId={currentLease.tenantId}
        />
      ) : (
        <div
          id="add-roommate"
          name="addRoommate"
          className="grid justify-items-center mt-20"
        >
          <BsPersonAdd
            className="text-7xl text-blue-500 hover:text-blue-700 border-blue-500
               hover:border-blue-700 border-2 rounded-full"
            onClick={() => {
              checkTenantAuth()
                ? handleModal("addRoommate")
                : handleAlert("tenantUpgrade");
            }}
          />
          <div className="text-slate-500 text-center mt-5 px-10">
            Add Tenant / Create Lease
          </div>
        </div>
      )}
      <div className="mb-32"></div>
      {/* <div className="flex justify-center w-full mt-10 mb-20 ">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("manageRoom")}
        />
      </div> */}
    </div>
  );
};

export default ManageRoom;
